export default "__VITE_ASSET__CPVjUhLz__"